
import ModalV3 from "@/app/ui/components/modal/modal-v3.vue";
import { Options, prop, Vue } from "vue-class-component";
import { AWB, FollowUpGroup } from "@/domain/entities/HangingIncoming";
import { AccountController } from "@/app/ui/controllers/AccountController";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean
  });
  awb = prop<AWB[]>({
    default: [],
    type: Array
  });
  group = prop<FollowUpGroup[]>({
    default: [],
    type: Array
  });
}

@Options({
  components: {
    ModalV3,
  }
})


class CopyTemplate extends Vue.with(Props) {
  copyText() {
    const el = document.getElementById("copy-text")
    if (el) {
      navigator.clipboard.writeText(el.innerText)
      this.setNotification();
    }
  }

  onCloseModal() {
    this.$emit("update:modelValue", false);
  }

  get companyName() {
    return AccountController.accountData.account_type_detail.company_name;
  }

  get getTotalPiece() {
    return this.group.reduce((sum, item) => sum + item.summary.totalPiece, 0)
  }

  get groupName() {
    return this.group.flatMap(item => item.groupName).join(", ");
  }

  get accountData() {
    return AccountController.accountData;
  }

  showToast = false;
  setNotification() {
      this.showToast = false;

    setTimeout(() => {
    this.showToast = true;
    }, 10);
  }

  get accountTypeMsg() {
    return this.accountData.isPosAccount
      ? this.$t("dashboard.hanging.accountTypePos")
      : this.$t("dashboard.hanging.accountTypeKonsolidator");
  }

}
export default CopyTemplate;
